import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { flat: "" }, {
    default: _withCtx(() => [
      (
                (_ctx.accountingPeriodsSuiteErrors && _ctx.accountingPeriodsSuiteErrors.length) ||
                (_ctx.missingAccountingPeriodLaps && _ctx.missingAccountingPeriodLaps.length)
            )
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            "no-gutters": "",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingPeriodsSuiteErrors, (suiteError, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '8',
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "default_card ma-0",
                      elevation: "0",
                      "pa-0": "",
                      style: {"margin":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "d-flex align-center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.$vuetify.display.mobile)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "1",
                                  class: "d-flex justify-center align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: "red",
                                      size: "x-large"
                                    }, {
                                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(" $alert ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }),
                            _createVNode(_component_v_col, {
                              cols: _ctx.$vuetify.display.mobile ? '8' : '7'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex align-center justify-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                          style: {"font-weight":"bold","font-size":"16pt","color":"red"}
                                        }, _toDisplayString(_ctx.formatDate(suiteError.end)), 3)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex align-center justify-start"
                                    }, {
                                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createElementVNode("strong", { class: "text-red" }, " Fin d'exercice chevauchant le début du suivant", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["cols"]),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex justify-center align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_tooltip, {
                                  location: "bottom",
                                  text: "Si les 2 périodes concernées sont vérrouillées, veuillez contacter le support."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn_icon, _mergeProps({ ref_for: true }, props, {
                                      icon: "$oss-help",
                                      color: "red"
                                    }), null, 16)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}